<template>
  <div class="pdpa-page">
    <v-img alt="Logo" class="shrink mr-2 app pdpa-logo" contain :src="logoimage" transition="scale-transition" />

    <v-sheet class="folded-corner pdpa-panel">
      <v-container>
        <header class="pdpa-header">
          <p>ONE BANGKOK</p>
          <h1>{{ $t("message.PrivacyPolicy") }}</h1>
        </header>

        <PDPA />
      </v-container>
    </v-sheet>


    <v-dialog v-model="LoadingDialog" persistent width="300">
      <v-card color="#1D2939" dark>
        <v-card-text class="white--text">
          <v-row>
            <p style="text-align: center;">Loading</p>
          </v-row>
          <v-row>
            <v-progress-linear indeterminate color="#ffffff" class="mb-0"></v-progress-linear>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
// import axios from "axios";
import enurl from "@/api/environment";
// import ChangeLanguage from "@/components/ChangeLanguage";
import PDPA from "@/components/PDPA";
// import logoimage from "@/assets/OneBangkokLogo.png";
export default {
  name: "PDPAPage",
  components: {
    // ChangeLanguage,
    PDPA
  },



  data() {
    return {
      url: enurl.apiUrl,
      settingUrl: enurl.settingUrl,
      DefaultLogo: "@/assets/logo192.png",
      DefaultBG: "@/assets/1D2939.png",
      Datetime: "",
      LoadingDialog: false,
      logoimage: "",
    };
  },
  mounted: function () {
    // setInterval(() => {
    //   this.getCurrentDate();
    // }, 1000);
       this.logoimage = require("@/assets/OneBangkokLogo.png");
  },

  methods: {

    getCurrentDate() {
      let self = this;
      let newDate = new Date();
      let date =
        newDate.getDate() < 10 ? "0" + newDate.getDate() : newDate.getDate();
      let month = newDate.getMonth() + 1;
      let year =
        newDate.getFullYear() < 2500
          ? newDate.getFullYear() + 543
          : newDate.getFullYear();
      let hours =
        newDate.getHours() < 10 ? "0" + newDate.getHours() : newDate.getHours();
      let minutes =
        newDate.getMinutes() < 10
          ? "0" + newDate.getMinutes()
          : newDate.getMinutes();
      let seconds =
        newDate.getSeconds() < 10
          ? "0" + newDate.getSeconds()
          : newDate.getSeconds();
      self.Datetime = `${date}/${month < 10 ? `0${month}` : `${month}`
        }/${year}  ${hours}:${minutes}:${seconds}`;
    },

    BackToMainPage() {
      let self = this;
      self.$router.push("/MainMenu");
    },

    GotoIdentifySelection() {
      let self = this;
      self.$router.push("/Ocr");
    },
  },
};
</script>
<style scoped>
.pdpa-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: clamp(14px, 2vh, 24px);
  padding: clamp(18px, 3vw, 42px);
}

.pdpa-page .pdpa-logo {
  width: min(27vw, 420px) !important;
  max-width: min(27vw, 420px) !important;
  margin: 0 !important;
}

.pdpa-page .pdpa-panel {
  width: min(1160px, calc(100vw - 160px)) !important;
  min-height: 0 !important;
  max-height: calc(100vh - 150px);
  margin: 0 auto !important;
  padding: clamp(22px, 2.8vw, 38px) !important;
}

.pdpa-header {
  text-align: center;
  margin-bottom: 16px;
}

.pdpa-header p {
  color: #344054;
  font-size: clamp(16px, 1.2vw, 22px);
  font-weight: 900;
  margin: 0 0 6px;
}

.pdpa-header h1 {
  color: #111827;
  font-size: clamp(40px, 4vw, 68px);
  font-weight: 900;
  line-height: 1.05;
  margin: 0;
}

@media all and (orientation: portrait) {
  .fullscreen {
    height: 1890px;
  }
}

@media all and (orientation: landscape) {
  .fullscreen {
    height: auto;
  }
}

.invisible-scrollbar::-webkit-scrollbar {
  display: none;
}
</style>
